export const FETCH_EMS = 'fetchEms'
export const FETCHED_EMS = 'fetchedEms'
export const CREATE_EMS = 'createEms'
export const CREATED_EMS = 'createdEms'
export const ENABLE_LOADING = 'enableLoading'
export const DISABLE_LOADING = 'disableLoading'
export const SET_EMS_STATUS = 'setEmsStatus'
export const EXPORT_EMS = 'exportEms'
export const EXPORTED_EMS = 'exportedEms'
